import React from "react";

import FullPageModal from "components/modals/FullPageModal";
import { ENOAH_REQUEST_MODAL } from "components/modals";
import {
  activeCaseFileSelector,
  activeCaseSelector,
  activeOrderFilesSelector,
  insuredListSelector,
  loadingSelector,
} from "../../../../reducers";
import { connect } from "react-redux";
import {
  fetchCaseFilesByCaseDocumentId,
  fetchInsured,
  fetchPolicy,
  generateEnoahOrder,
  hideModal,
  sendEnoahOrder,
  showModal,
} from "../../../../actions";
import File from "../../../../components/File";
import { Table } from "react-bootstrap";
import * as notifications from "notifications";

const EnoahModal = ({ ...props }) => {
  let [sending, setSending] = React.useState(false);
  let [missingHIPAA, setMissingHIPAA] = React.useState(true);
  let [missingAPS, setMissingAPS] = React.useState(true);

  React.useEffect(() => {
    props.generateEnoahOrder(props.activeCaseFile.id);
  }, []);

  const SendButton = () => {
    let message = "Send eNoah Order";
    if (sending) {
      message = (
        <>
          Sending... <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" />
        </>
      );
    }
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <button
          className="btn btn--secondary"
          onClick={async () => {
            try {
              setSending(true);
              await props.sendEnoahOrder(props.activeCaseFile.id);
              await props.fetchCaseFilesByCaseDocumentId(props.activeCaseFile.id);
              props.hideModal(ENOAH_REQUEST_MODAL);
            } catch (e) {
              console.log(e);
              notifications.error("Error sending eNoah Order");
              setSending(false);
            }
          }}
          style={{
            width: "50%",
            marginBottom: "1rem",
          }}
          disabled={sending || missingHIPAA || missingAPS}
        >
          {message}
        </button>
      </div>
    );
  };

  const EnoahFilesTable = () => {
    let possible_hipaa = ["HIPAA", "HIPAALR"];
    let possible_aps = ["EHR", "EHRE", "EHRH", "QHPIQ", "MR"];
    let enoahOrderFiles = props.activeOrderFiles?.enoah_order_files || [];
    setMissingHIPAA(true);
    setMissingAPS(true);
    for (let file of enoahOrderFiles) {
      if (possible_hipaa.includes(file.fr_id)) {
        setMissingHIPAA(false);
      } else if (possible_aps.includes(file.fr_id)) {
        setMissingAPS(false);
      }
    }

    return (
      <>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Type</th>
              <th>File</th>
            </tr>
          </thead>
          <tbody>
            {missingHIPAA && !props.loading.enoahOrderFiles && (
              <tr>
                <td colSpan={2} style={{ color: "red", fontWeight: "bold" }}>
                  Missing HIPAA file in Status Received IGO
                </td>
              </tr>
            )}
            {missingAPS && !props.loading.enoahOrderFiles && (
              <tr>
                <td colSpan={2} style={{ color: "red", fontWeight: "bold" }}>
                  Missing APS file in Status Received IGO
                </td>
              </tr>
            )}
            {props.loading.enoahOrderFiles && (
              <tr>
                <td colSpan={2}>Loading files...</td>
              </tr>
            )}
            {props.activeOrderFiles?.enoah_order_files?.map((file, index) => (
              <tr key={index}>
                <td>{file.type}</td>
                <td>
                  <File style={{ marginBottom: 0 }} file={file} />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <br />
        <SendButton />
      </>
    );
  };

  return (
    <FullPageModal modalType={ENOAH_REQUEST_MODAL} title={"eNoah Request"}>
      <EnoahFilesTable />
    </FullPageModal>
  );
};

const mapStateToProps = state => {
  return {
    caseInfo: activeCaseSelector(state),
    activeCaseFile: activeCaseFileSelector(state),
    activeOrderFiles: activeOrderFilesSelector(state),
    insuredList: insuredListSelector(state),
    loading: loadingSelector(state),
  };
};

export default connect(mapStateToProps, {
  generateEnoahOrder,
  sendEnoahOrder,
  fetchPolicy,
  fetchInsured,
  fetchCaseFilesByCaseDocumentId,
  showModal,
  hideModal,
})(EnoahModal);
